var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiBadgeEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70761 1.81761C7.15989 2.28431 6.47892 2.56636 5.76161 2.62361C4.95086 2.68811 4.18963 3.03943 3.61453 3.61453C3.03943 4.18963 2.68811 4.95086 2.62361 5.76161C2.56636 6.47892 2.28431 7.15989 1.81761 7.70761C1.28988 8.32652 1 9.11325 1 9.92661C1 10.74 1.28988 11.5267 1.81761 12.1456C2.28431 12.6933 2.56636 13.3743 2.62361 14.0916C2.68811 14.9024 3.03943 15.6636 3.61453 16.2387C4.18963 16.8138 4.95086 17.1651 5.76161 17.2296C6.47892 17.2869 7.15989 17.5689 7.70761 18.0356C8.32652 18.5633 9.11325 18.8532 9.92661 18.8532C10.74 18.8532 11.5267 18.5633 12.1456 18.0356C12.6933 17.5689 13.3743 17.2869 14.0916 17.2296C14.9024 17.1651 15.6636 16.8138 16.2387 16.2387C16.8138 15.6636 17.1651 14.9024 17.2296 14.0916C17.2869 13.3743 17.5689 12.6933 18.0356 12.1456C18.5633 11.5267 18.8532 10.74 18.8532 9.92661C18.8532 9.11325 18.5633 8.32652 18.0356 7.70761C17.5689 7.15989 17.2869 6.47892 17.2296 5.76161C17.1651 4.95086 16.8138 4.18963 16.2387 3.61453C15.6636 3.03943 14.9024 2.68811 14.0916 2.62361C13.3743 2.56636 12.6933 2.28431 12.1456 1.81761C11.5267 1.28988 10.74 1 9.92661 1C9.11325 1 8.32652 1.28988 7.70761 1.81761Z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBadgeEmpty);
export default __webpack_public_path__ + "static/media/HiBadgeEmpty.2a622068.svg";
export { ForwardRef as ReactComponent };